module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-hedo-01@2x.bfde1148.png";